/**
 * PC 레이아웃 기준값.
 *
 * CSS 에서는 globalStyles 가 심어주는 커스텀 프로퍼티(--pc-width)를 쓰고,
 * 폭을 직접 재야 하는 JS 에서는 여기 상수를 import 한다.
 * 파생값(절반, n분할 등)은 손으로 계산하지 말고 calc() 로 뽑는다.
 */

/** PC 컨텐츠 컨테이너 폭 */
export const PC_CONTAINER_WIDTH = 1326;
